"use strict";

exports.__esModule = true;
exports.resolveStructuredData = resolveStructuredData;

function resolveStructuredData(structuredDataString) {
  if (structuredDataString === void 0) {
    structuredDataString = '{}';
  }

  try {
    var dataObject = JSON.parse(structuredDataString);
    return clearEmptyFields(dataObject);
  } catch (error) {
    return '{}';
  }
}

function clearEmptyFields(dataObject) {
  if (dataObject === void 0) {
    dataObject = {};
  }

  if (!dataObject) {
    return '{}';
  }

  Object.entries(dataObject).forEach(function (_ref) {
    var key = _ref[0],
        val = _ref[1];

    if (val && typeof val === 'object') {
      clearEmptyFields(val);
    } else {
      if (!val || val === null || val === '') {
        delete dataObject[key];
      }
    }
  });
  return JSON.stringify(dataObject);
}